export const MANAGE_ALERTS_CTA_PATH = 'cod.mail_preferences';
export const MANAGE_ALERTS_CTA_TRACKING_PARAMETERS =
  'utm_source=trovit&utm_medium=web&utm_campaign=manage_alerts';



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/CallToActionLink/constants.js